<template>
  <div class="fotos">
    <Header
      :pageTitle = "navigation.fotos.headerTitle[lang]"
      schema="default"
    />
    <b-container class="pb-1"
      v-if="pageData"
    >
      <Breadcrumb
        :pathToPage="pathToThisPage"
      />
      <b-row>
        <b-col
          md="12"
          id="subjects"
        >
        <div
          v-if="pageData.body && subSubjects"
          v-html="normalize(pageData.body)"
          class="lead lead-box mb-4"
        />
        </b-col>
        <b-col
          md="12"
          class="shadow p-4 mb-4 text-center"
        >
        <h5
          class=""
        >
          {{ staticData['fotosOn'] }}
        </h5>
        <h5
          class="small d-inline-block"
          v-for="(subSubject, index) in sortedSubSubjects"
          :key="`navi-sub-${index}`"
        >
            <span
              class="mx-2 scroll-to-sub"
              @click="scrollToSub(subSubject.id)"
            >
               {{ subSubject.titel }}
            </span>
        </h5>
        </b-col>
      </b-row>
      <b-row
        v-for="(subSubject, sIndex) in sortedSubSubjects"
        :key="`subSubEgs-${sIndex}`"
      >
        <b-col
          lg=12
          class="shadow p-4 mb-4 d-flex justify-content-between align-items-start"
        >
          <div>
            <h5
              :id="`sub-${subSubject.id}`"
            >
            {{ subSubject.titel  }}</h5>
            <span v-show="fotosForSub(subSubject.id).length > intitialShowFotos">
              {{ fotosForSub(subSubject.id).length }} {{ staticData['fotos'] }}
            </span>
          </div>
          <div
            class="back-to-top"
            @click="backToTop()"
          >
            &#8593;
          </div>

        </b-col>
        <b-col
          v-for="(foto, index) in fotosForSub(subSubject.id)"
          :key="index"
          :ref="`card-${index}-${subSubject.id}`"
          sm=6
          md=4
          lg=3
          xl=2
          class="mb-3 video-listing d-flex flex-column justify-content-between"
        >
          <template
            v-if="index < intitialShowFotos || showAllFotos.includes(subSubject.id.toString())"
          >
            <div
              class=""
            >
              <div
                class="d-flex flex-column justify-content-between align-self-stretch "
              >
                <template
                  v-if="!foto.titelNichtVerwenden"
                >
                  <b-link
                    v-if="foto.mehrAnzeigen === '1'"
                    router-tag="h4"
                    :to="`/medien/fotos/${foto.slug}/${lang}`"
                    class="dhn-clickable mt-2 mb-4 card-title"
                  >
                    {{ foto.titel }}
                  </b-link>
                  <h4
                    v-else
                    class="mt-2 mb-4 card-title"
                  >
                    {{ foto.titel }}
                  </h4>
                </template>
                <div
                  class="image clickable"
                  @click="toggleEnlargeState(foto)"
                >
                  <img
                    :src="foto.symbolbild"
                    :alt="`Image: ${foto.titel}`"
                    :ref="`image-${index}-${subSubject.id}`"
                    @load="adjustDisplay(index, subSubject.id)"
                  >
                  <EnlargeIcon :dir="enlargeState"/>
                </div>
                <div
                  v-html="normalize(foto.kurztext)"
                />
              </div>
            </div>
            <span
              v-if="editMode"
              class="dhn-clickable edit-button"
            >
                <a :href="editLink(foto.id)" target="_blank" alt="edit item in Bolt">&#9998;</a>
            </span>
            <MehrButton
                v-if="foto.mehrAnzeigen === '1'"
                :linkTo="`/medien/fotos/${foto.slug}/${lang}`"
            />
          </template>
        </b-col>
        <b-col
          lg=12
          class="px-4 mb-2"
          v-if="fotosForSub(subSubject.id).length - intitialShowFotos > 0 && !showAllFotos.includes(subSubject.id)"
        >
          <!-- Weitere Fotos zu diesem Thema -->
          <b-link
            @click="showAllFotosFor(subSubject.id)"
          >
            {{ staticData['showMoreFotos'] }} ({{ fotosForSub(subSubject.id).length - intitialShowFotos }}) ...
          </b-link>
        </b-col>
      </b-row>
    </b-container>
    <Modal />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Header from '@/components/Header.vue'
import Breadcrumb from '@/components/subparts/Breadcrumb-subpart.vue'
import MehrButton from '@/components/subparts/Mehr-button-subpart.vue'
import EnlargeIcon from '@/components/subparts/Enlarge-icon-subpart.vue'
import initView from '../mixins/initView'
import Modal from '@/components/Modal.vue'

export default {
  name: 'fotos',
  data () {
    return {
      hbg: '',
      currentPage: 1,
      videosPerPage: 12,
      intitialShowFotos: 8,
      showAllFotos: [],
      enlargeState: 'enlarge'
    }
  },
  components: {
    Header,
    Breadcrumb,
    MehrButton,
    Modal,
    EnlargeIcon
  },
  mixins: [
    initView
  ],
  methods: {
    ...mapActions({
      setEditMode: 'setEditMode',
      toggleModal: 'toggleModal'
    }),
    adjustDisplay (index, id) {
      const imageRef = this.$refs['image-' + index.toString() + '-' + id.toString()]
      const cardRef = this.$refs['card-' + index.toString() + '-' + id.toString()]
      const ratio = imageRef[0].naturalWidth / imageRef[0].naturalHeight > 1
        ? 'landscape'
        : 'portrait'
      if (ratio === 'landscape') {
        cardRef[0].classList.remove('col-xl-3')
        cardRef[0].classList.add('col-xl-4')
        cardRef[0].classList.remove('col-lg-3')
        cardRef[0].classList.add('col-lg-4')
        cardRef[0].classList.remove('col-md-4')
        cardRef[0].classList.add('col-md-6')
        cardRef[0].classList.remove('col-sm-6')
        cardRef[0].classList.add('col-md-12')
      }
    },
    toggleEnlargeState (foto) {
      this.toggleModal()
      this.$store.state.currModalImage.src = foto.symbolbild
      this.$store.state.currModalImage.title = foto.titel
    },
    editLink (id) {
      return `https://bolt-dev.dh-north.org/bolt/editcontent/medienobjekte/${id}`
    },
    fetchData () {

    },
    scrollToSub (subId) {
      this.$router.push(`#sub-${subId}`)
    },
    backToTop () {
      this.showAllFotos = []
      this.$router.push(`/medien/fotos/${this.lang}`)
      this.$router.push('#subjects')
    },
    fotosForSub (id) {
      return this.groupedFotos.subs.find(s => s.id === id).fots
    },
    showAllFotosFor (id) {
      this.showAllFotos.push(id)
    },
    videosWithoutSub () {

    }
  },
  computed: {
    ...mapGetters({
      pageData: 'getAllFotosPageData',
      fotos: 'getAllFotosData',
      mos: 'getAllMediaObjectsData',
      lang: 'getLanguage',
      navigation: 'getNavigation',
      newRoute: 'getNewRoute',
      staticData: 'getStaticData',
      subSubjects: 'getAllSubsubjectsData',
      editMode: 'getEditMode',
      fotosSubSubjects: 'getFotosSubSubjects',
      modalState: 'modalState'
    }),
    pathToThisPage () {
      let path = []
      let nav = this.$store.state.navigation
      let lang = this.lang
      path[0] = {
        name: nav.home.navTitle[lang],
        slug: '/',
        disabled: false
      }
      path[1] = {
        name: nav.sammlungen.navTitle[lang],
        slug: `/sammlungen/${lang}`,
        disabled: false
      }
      path[2] = {
        name: nav.fotos.navTitle[lang],
        slug: `/medien/fotos/${lang}`,
        disabled: true
      }
      return path
    },
    numberPages () {
      return Math.ceil(this.videos.length / this.videosPerPage)
    },
    groupedFotos () {
      let subs = this.subSubjects
      let fots = [...this.fotos]
        .sort((a, b) => {
          return a.page_order - b.page_order
        })
      subs.forEach(s => {
        s.fots = fots.filter(f => {
          return f.subs
            ? f.subs.includes(s.id)
            : undefined
        })
      })
      return { fots, subs }
    },
    sortedSubSubjects () {
      let subSubs = [...this.subSubjects].filter(ss => {
        return this.fotosSubSubjects.includes(ss.id)
      })
        .sort((a, b) => {
          return a.collection_order - b.collection_order
        })
      return subSubs
    }
  },
  created () {
    this.$store.dispatch('fetchData', 'fotosPage')
    this.$store.dispatch('fetchBoltAllSubSubjectsData')
    const code = sessionStorage.getItem('editModeCode') ? sessionStorage.getItem('editModeCode') : 1
    this.setEditMode(code)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.image {
      position: relative;
      display: inline-block;
      img {
        max-width: 100%;
      }
      .enlarge-icon {
        position: absolute;
        width: 2rem;
        height: 2rem;
        bottom: 1rem;
        right: 1rem;
        z-index: 100;
      }
  }
  .clickable {
    cursor: pointer;
  }

.video-disabled,
.thumbnail-disabled {
  display: none;
}
a.start,
a.end {
  color: #eee;
  cursor: auto;
}
a.start:hover,
a.end:hover {
  background: transparent;
}
.current-page{
  background: #4682B4;
  color: #fff;
}
.scroll-to-sub {
  cursor: pointer;
}
.scroll-to-sub:hover{
    text-decoration: underline;
}
.back-to-top {
  color: #4682B4;
  font-size: 1.4rem;
  padding: .2rem 1rem .4rem;
  border: 1px solid #4682B4;
  cursor: pointer;
}
.back-to-top:hover {
  background-color:#eee
}
.edit-button {
  text-align: right;
}
.edit-button a {
  display: inline-block;
  color: orange;
  font-size: 1.2rem;
  padding: .2rem .6rem;
  border: 1px solid orange;
  text-decoration: none;
}
.card-title {
  min-height: 2.4rem;
  font-size: 1rem;
}
</style>
